import React from "react";
import { PaginationButton } from "../buttonComponent/ButtonComponent";
import "./Table.css";

export default function TablePagination({
  currentPage,
  totalPages,
  handlePreviousPage,
  handleNextPage,
  hasData,
  total,
  module,
}) {
  const getModule = (module) => {
    switch (module) {
      case "scheduling":
        return "Schedules";
      case "attendance":
        return "Students";
      case "vehicles":
        return "Vehicles";
      case "drivers":
        return "Drivers";
      case "stops":
        return "Stops";
      case "trips":
        return "Trips";
      case "admin":
        return "Administrators";
      case "family":
        return "Families";
      case "parent":
        return "Parents";
      case "child":
        return "Children";
      case "notifications":
        return "Campaigns";
      case "stopsArray":
        return "Stops";
      default:
        return "Records";
    }
  };

  return (
    <div className="pagination-controls">
      {total && (
        <div className="pagination-total">{`${total} ${getModule(
          module
        )} Total`}</div>
      )}
      {module !== "stopsArray" && (
        <div
          className="pagination-info"
          style={!total ? { paddingLeft: "1rem" } : {}}
        >
          {totalPages > 0 ? `Page ${currentPage} of ${totalPages}` : `Page 1`}
        </div>
      )}
      {module !== "stopsArray" && (
        <div className="pagination-buttons">
          <PaginationButton
            onClick={() => handlePreviousPage(currentPage - 1)}
            disabled={!hasData || currentPage === 1}
            direction="previous"
          />
          <PaginationButton
            onClick={() => handleNextPage(currentPage + 1)}
            disabled={!hasData || currentPage === totalPages}
            direction="next"
          />
        </div>
      )}
    </div>
  );
}
